import view from '@/mixins/view'
import TweenMax from 'gsap'

import { populate, sort } from '@/data'

export default {
  name: 'tpl-partners',
  mixins: [view],
  data () {
    return {
      fetched: false,
      page: null,
      partners: [],
      slides: [],
      industries: [],
      showFilter: false,
      currentFilter: ''
    }
  },

  created () {
    this.getPage().then(() => {
      if (!this.page) this.$router.push({ name: 'not-found' })

      this.processPartners()

      this.preloadAssets().then(() => {
        // this.ready = true
        this.fetched = true
      })
    })
  },
  mounted () {
    document.body.classList.add('fullscreen')
    this.$nextTick(() => {

    })
  },
  beforeDestroy () {
    document.body.classList.remove('fullscreen')
  },
  methods: {
    fetchData: async function (store, params) {
      return Promise.all([
        store.getters.get('page', params.post_id),
        store.getters.get('partner'),
        store.getters.get('industry')
      ]).then(([page, partners, industries]) => {
        return { page, partners, industries }
      })
    },
    preloadAssets: async function () {
      return Promise.all(this.partners.map(partner => {
        return this.fetch(this.getCleanLink(this.getImageUrl(partner.meta.cover.image_desktop, 'cover-desktop')))
      }))
    },
    getPage: async function () {
      await this.fetchData(this.$store, this.$attrs).then(({ page, partners, industries }) => {
        partners = sort(partners, 'title', 'asc')
        industries = sort(industries, 'title', 'asc')
        partners = populate(partners, industries, 'industry')
        
        partners = partners.sort((a, b) => 0.5 - Math.random())

        this.page = page
        this.partners = partners
        this.industries = industries
      })
    },
    processPartners () {
      this.partners.forEach((partner, key) => {
        const termIds = []
        if (partner.meta.industry) termIds.push(partner.meta.industry.id)

        this.slides.push({
          id: key,
          image: this.platform === 'mobile' ? partner.meta.cover.image_mobile : partner.meta.cover.image_desktop,
          title: partner.title,
          link: partner.link,
          backgroundColor: partner.meta.color ? partner.meta.color : '#000',
          terms: termIds
        })
      })
    },
    setFilter (term) {
      this.toggleFilters()
      history.pushState({}, null, `${window.location.origin}${window.location.pathname}?${term.slug}`)
      this.handleFilter()
    },
    removeFilter () {
      history.pushState({}, null, `${window.location.origin}${window.location.pathname}`)
      this.handleFilter()
      if (this.showFilter) this.toggleFilters()
    },
    handleFilter () {
      if (window.location.search) {
        const terms = Array.from(this.industries)
        let found
        terms.forEach(term => {
          if (!found && window.location.search.includes(term.slug)) {
            found = term
          }
        })
        if (found) {
          this.$refs.slider && this.$refs.slider.filter('terms', found.id)
          this.currentFilter = found
          return
        }
      }
      this.$refs.slider && this.$refs.slider.filter('terms')
      this.currentFilter = undefined
    },
    toggleFilters () {
      this.showFilter = !this.showFilter
    },
    onSliderReady () {
      this.ready = true
      this.$nextTick(() => {
        this.handleFilter()
      })
    }
  }
}
